import grapesjs from 'drapcode-builder';
import loadTraits from './traits';

/**
 * This traits is obsolete, can enable/enhance it when we figure out auto complete (Select2 feature) in
 * traits dropdown.
 * Enable it by registering it in geditorBuild.js
 */

export default grapesjs.plugins.add('drapcode-prebuilt-classes-traits', (editor, opts) => {
  //This will add trait to all the default type components.
  let defaultType = editor.DomComponents.getType('default');
  let _initialize = defaultType.model.prototype.initialize;
  defaultType.model.prototype.initialize = function () {
    _initialize.apply(this, arguments);

    const traitsSize = this.get('traits').length;
    const globalClassTraits = this.getTrait('data-drapcodeClass');

    if (!globalClassTraits) {
      this.get('traits').add(
        {
          type: 'drapcode-prebuilt-classes',
          name: 'data-drapcodeClass',
          label: 'Global Class',
        },
        // { at: 0 },
        { at: traitsSize },
      );
    }
  };

  const default_traits = {
    text: {
      type: 'drapcode-prebuilt-classes',
    },
  };
  let options = {
    ...{
      traits: default_traits,
    },
    ...opts,
  };

  loadTraits(editor, options);
});
